<div>
	<h1 style=" color: white;">Diagrama de Recetas</h1>
	<!-- <span style="color: white !important; backdrop-filter: invert(1);">Haz click sobre el puesto para ver las personas que se han contratado</span> -->
</div>
<div class="chart">
	<div class="chart-container" #chartContainer></div>
</div>